module.exports = __webpack_public_path__ + "img/zx-banner.66b27a07.png";